import type { OrderShowData } from "~/models/Order"

export function useOrder() {
    return useState<OrderShowData | null>("orderShowData", () => null)
}
